import React, { useState } from "react";
import { useDispatch } from "react-redux";
import * as Mui from "@mui/material";
import { Box, Typography } from "@mui/material";
import { AwaitingApproval } from "./AwaitingApproval";
import { Completed } from "./Completed";
import { Inprogress } from "./Inprogress";
import { setGlobalSearchValue } from "services/Redux/userToken";

export const Incentive = () => {
  const [selectedComponent, setSelectedComponent] = useState("InProgress");
  const dispatch = useDispatch();

  const renderComponent = () => {
    switch (selectedComponent) {
      case "Awaiting":
        return <AwaitingApproval />;
      case "InProgress":
        return <Inprogress />;
      case "Completed":
        return <Completed />;
      default:
        return null;
    }
  };

  const tabStyle = (tab) => ({
    padding: "12px 24px",
    backgroundColor: selectedComponent === tab ? "white" : "transparent",
    color: selectedComponent === tab ? "primary.main" : "text.secondary",
    fontWeight: 600,
    cursor: "pointer",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    marginBottom: "-1px",
  });

  return (
    <React.Fragment>
      <Box>
        {/* Header */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
            Incentive Payout
          </Typography>
          <Typography variant="body2" color="text.secondary">
            The Incentive Payout Processing screen is used to calculate, review
            ,approve and complete employee incentive payrout as part of the
            payroll process.
          </Typography>
        </Box>

        {/* Tabs */}
        <Box sx={{ display: "flex", gap: 2, ml: 5 }}>
          <Box
            sx={tabStyle("InProgress")}
            onClick={() => {
              dispatch(setGlobalSearchValue(""));
              setSelectedComponent("InProgress");
            }}
          >
            In Progress
          </Box>
          <Box
            sx={tabStyle("Awaiting")}
            onClick={() => {
              dispatch(setGlobalSearchValue(""));
              setSelectedComponent("Awaiting");
            }}
          >
            Awaiting Approval
          </Box>
          <Box
            sx={tabStyle("Completed")}
            onClick={() => {
              dispatch(setGlobalSearchValue(""));
              setSelectedComponent("Completed");
            }}
          >
            Completed
          </Box>
        </Box>
      </Box>

      {/* Render Selected Component */}
      <Mui.Grid container sx={{ paddingTop: 0.1 }}>
        {renderComponent()}
      </Mui.Grid>
    </React.Fragment>
  );
};
